module.exports = __webpack_public_path__ + "static/media/grid_white.a4669693.svg";